import { map, compact, first } from 'underscore';

import reduce from 'lodash/reduce';

const LOCATION_UNKNOWN = 'UNKNOWN';
const LOCATION_TURBINE = 'TURBINE';

export const handleIncomingPeople = (m) => {
    let turbineId = LOCATION_UNKNOWN;
    if (m.location_type.value === LOCATION_TURBINE) {
        turbineId = m.location_key.value;
    } else if (m.last_known_location_type.value === LOCATION_TURBINE) {
        turbineId = m.last_known_location_key.value;
    }

    return { ...m, turbine_denormalised: { value: turbineId } };
};

const timeStampAttributes = [
    'return_time.value',
    'release_time.value', // ROP
    'end_time.value',
    'start_time.value', // VISITOR_LOG
];
const timeStampGuesser = (obj) => {
    const allValues = map(timeStampAttributes, (attr) => {
        if (attr.match(/.+\..+/)) {
            return attr.split('.').reduce((a, b) => (a === null ? null : a[b] || null), obj);
        }
        return obj[attr];
    });
    return first(compact(allValues));
};

export const handleIncomingLog = (m) => {
    const mergedId = m.entityType + m.entityKey;
    let timestampIndex = timeStampGuesser(m);
    const ts = new Date(timestampIndex);
    if (!Number.isNaN(ts.valueOf())) {
        // check if it is a proper date object
        timestampIndex = -ts.valueOf(); // make it neagtive for sorting
    }

    return {
        ...m,
        entityKey: mergedId,
        timestamp_index: timestampIndex,
    };
};

export const checkNewVisitor = (oldArray, location, newItem) => {
    if (newItem.location_type.value === location) {
        const hasVisitor = oldArray.find((item) => item.name.value === newItem.name.value);

        if (hasVisitor === undefined) {
            oldArray.push(newItem);
        }
        return oldArray;
    }

    // Visitor has come Off this 'location'
    // remove item by name and only if new items is newer, to prevent wrong counts on initial load.
    // We need this so I user has window open and new items are coming in from WS, the counts are correct

    return oldArray.filter((current) => {
        if (current.name.value === newItem.name.value) {
            return current.ts.value > newItem.ts.value;
        }
        return true;
    });
};

export const checkNewVisitors = (oldArray, location, newItems) => {
    const updatedVisitors = reduce(
        newItems,
        (visitorsReduces, visitor) => checkNewVisitor(visitorsReduces, location, visitor),
        oldArray
    );

    return updatedVisitors;
};
